import Vue from 'vue';
import Router from 'vue-router';
import ls from 'local-storage';

// lazy loading
const Home = () => import('././../components/Home.vue');
const Login = () => import('././../components/auth/Login.vue');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'Faturamento',
      component: Home,
      meta: {
        humanName: 'Faturamento',
        pathAlias: ['Listagem dos clientes'],
        showOnNav: true,
        icon: 'home-icon',
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        humanName: 'Login',
        pathAlias: ['Users', 'Login'],
      },
    },
    { path: '*', component: Home, meta: {}},
  ],
});

router.beforeEach((to, from, next) => {
  const token = ls('token');
  if (!token && (to.name !== 'Login')) {
    next('/login');
  } else {
    next();
  }
});

export default router;
